function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_5934_141433)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.1596 19.9962C18.1596 19.9962 17.3267 20.1295 19.5995 18.5613C20.4135 17.9997 21.3705 17.6846 22.3495 17.6557C23.3286 17.6268 24.2857 17.8855 25.0998 18.3991C25.9139 18.9127 26.5485 19.6581 26.9234 20.541C27.2982 21.4239 27.3963 22.4048 27.2055 23.3595C27.0146 24.3142 26.5433 25.1998 25.8511 25.9045C25.159 26.6091 24.277 27.1011 23.3168 27.3182C22.3566 27.5353 21.3613 27.4678 20.4567 27.1242C19.5521 26.7805 18.7789 26.1763 18.2349 25.3877",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.2928 16.6676L17.6105 20.0808L21.0437 20.6545",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.3702 12.4315C20.8232 8.66909 28.2044 9.90244 31.8493 15.185C35.4941 20.4676 34.0271 27.806 28.5741 31.5684C23.1211 35.3308 15.7399 34.0974 12.0951 28.8148C8.45023 23.5322 9.91723 16.1939 15.3702 12.4315Z",
  stroke: "black",
  strokeMiterlimit: 10
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_5934_141433"
}, /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 31,
  fill: "white",
  transform: "matrix(-0.823092 0.567909 0.567909 0.823092 26.339 0.155518)"
})));

function SvgIcBackPodcast(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBackPodcast);
export default __webpack_public_path__ + "static/media/ic_back_podcast.2f30a2da.svg";
export { ForwardRef as ReactComponent };